import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    position: relative;
  }
`;

export const PhraseStyles = styled.div`
  position: absolute;
  bottom: 180px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  width: 45%;
  font-size: 0;
  aspect-ratio: 1.435;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ActionsStyles = styled.div`
  width: calc(100% - 40px);
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 12px;
  border: 0.5px solid #9777aa;
  background: rgba(26, 11, 32, 0.5);
  backdrop-filter: blur(11.5px);
  will-change: backdrop-filter, background;
  padding: 20px 16px;
`;

export const ActionsLabelStyles = styled(UiTypography)`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin: 0 0 12px;
  max-width: 100%;

  .app-name-colored {
    color: #9660ff;
  }
`;

export const StoreLinksStyles = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;

  a {
    display: inline-block;
    width: 185px;
    aspect-ratio: 3.4;
    font-size: 0;
    line-height: 0;

    @media screen and (min-width: 360px) {
      width: 240px;
    }

    @media screen and (min-width: 576px) {
      width: 280px;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
`;
